<template>
<v-app>
  <v-container light>
    <v-flex column>
      <v-layout row justify-center style="margin-top:5px;" mb-3>
        <img v-if="rolCliente || rolProveedor" v-bind:src="base64RolCliente" height="160" style="margin-top:8px;"/>
        <img v-else :src="require('@/assets/images/logo.png')" height="160" style="margin-top:8px;"/>

      </v-layout>
      <v-layout row justify-center style="margin-top:5px;" mb-2>
        <span class="grey--text headline proxima-semi" xs2>{{titulo}}</span>
      </v-layout>
    </v-flex>
    <v-layout justify-center mb-3>
      <span class="reddy--text title proxima-semi" xs2>{{localizationLogin.subtitle}}</span>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs4 x4 justify-center>
        <v-card style="padding:20px" >
          <v-form v-model="valid" id="valid">
            <v-text-field
              v-model="usermail" id="usermail"
              :name="usermail"
              :rules="[rules.required, rules.email]"
              :label="localizationLogin.user"
              autofocus
            />
            <v-text-field
              v-model="password" id="password"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :rules="[rules.required]"
              :type="showPassword ? 'text' : 'password'"
              :name="password"
              :label="localizationLogin.password"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-layout row>
              <v-spacer/>
              <v-btn text @click="resetPassword()" class="reddy--text proxima-semi">
                {{localizationLogin.forgotPassword}}
              </v-btn>
            </v-layout>
          </v-form>
          <v-layout justify-center style="padding-top:30px">
            <v-btn class="proxima-semi" color="primary" :disabled="!valid || botonDesactivado" :loading="botonDesactivado" @click="loguear(usermail, password)">
              {{localizationLogin.button}}
            </v-btn>
          </v-layout>
                <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-on="on" v-bind="attrs" @click="toggleSelectLanguage = !toggleSelectLanguage" style="justify-content: end;">mdi-web</v-icon>
                </template>
                <v-list>
                  <v-list-item
                    v-for="idioma in idiomas"
                    :key="idioma.clave"
                    @click="cambiarIdioma(idioma.clave)"
                  >
                    <v-list-item-title>{{ idioma.descripcion }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
          <v-spacer></v-spacer>
        </v-card>
      </v-flex>
    </v-layout>
    <!--<v-btn absolute bottom right small style="bottom:70px" @click="formularioPV1">{{ version1 }}</v-btn>-->
    <v-footer absolute class="font-weight-medium">
      <v-col cols="12" class="text-right">
        <span class="caption primary--text">{{ this.$t('revisionBackend')}}: {{versionApi}} {{ this.$t('revisionFrontend')}}: {{version}}</span>
      </v-col>
    </v-footer>

    <v-dialog v-model="dialog" id="dialog" persistent max-width="290">
      <PopUpVolverPv1
        @cancelar="dialog = false"
        @aceptar="iraPV1"
      />
    </v-dialog>
  </v-container>
</v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { enableScroll } from '@/components/transitions/scrollDisabler'
import rulesMixin from '@/components/generic/rules.js'
import PopUpVolverPv1 from './PopUpVolverPv1'

export default {
  mixins: [rulesMixin],
  components: {
    PopUpVolverPv1
  },
  data () {
    return {
      valid: false,
      toggleSelectLanguage: false,
      botonDesactivado: false,
      password: '',
      usermail: '',
      OSUserId: null,
      codigoClientePrinex: null,
      showPassword: false,
      rules: {
        required: value => !!value || 'Required.'
      },
      dialog: false,
      base64RolCliente: null,
      rolCliente: false,
      rolProveedor: false,
      titulo: '',
      idiomas: [
        {
          clave: 'es',
          descripcion: this.$t('es')
        },
        {
          clave: 'en',
          descripcion: this.$t('en')
        },
        {
          clave: 'eu',
          descripcion: this.$t('eu')
        }
      ]
    }
  },
  mounted () {

    let cliente = this.$route.query.cl || false
    let proveedor = this.$route.query.prov || false
    this.setAgrupacionRolProveedor(null)
    this.setSubdominioRolProveedor(null)
    if(cliente) {

      this.rolCliente = true
      // obtenemos el icono del cliente
      this.obtenerDatosSuscriptor({
        cliente: cliente,
        codapp: 11
      }).then((configuracion) => {
        this.base64RolCliente = 'data:image/png;base64,' + configuracion.LOGO_EMPRESA_LOGIN_PVC
        this.titulo = configuracion.CONFIG__NOMBRE_COMERCIAL
      })
    } else if (proveedor) {

      this.rolProveedor = true
      // obtenemos el icono del cliente
      this.obtenerDatosSuscriptor({
        cliente: proveedor,
        codapp: 12
      }).then((configuracion) => {
        this.base64RolCliente = 'data:image/png;base64,' + configuracion.LOGO_EMPRESA_LOGIN_PVP
      })

    } else {
      this.titulo = this.localizationLogin.title
    }
    this.obtenerVersionWS()
    document.documentElement.style.overflowY = 'auto'
    document.documentElement.className = ''
    document.body.className = ''
    enableScroll()
    if(this.$route.query.autologin) {
      var autologin = atob(this.$route.query.autologin).split(":")
      this.codigoClientePrinex = autologin[0]
      this.usermail = autologin[1]
      this.password = btoa(autologin[2])

      this.loguear (autologin[1], autologin[2])

    }


  },
  methods: {
    ...mapMutations({
      setAgrupacionRolProveedor: 'setAgrupacionRolProveedor',
      setSubdominioRolProveedor: 'setSubdominioRolProveedor'
    }),
    ...mapActions({
      logIn: 'login/logIn',
      addAlert: 'alerts/add',
      obtenerTiposSolicitud: 'configuracion/obtenerTiposSolicitud',
      obtenerConfiguracion: 'configuracion/obtenerConfiguracion',
      guardarConfiguracionInicial: 'configuracion/guardarConfiguracionInicial',
      guardarTraduccionesPorDefecto: 'configuracion/guardarTraduccionesPorDefecto',
      cierreAutomaticoIncidencias: 'incidencias/cierreAutomaticoIncidencias',
      obtenerVersionWS: 'obtenerVersionWS',
      enviarMensajePV1: 'login/enviarMensajePV1',
      obtenerDatosSuscriptor: 'obtenerDatosSuscriptor'
    }),
    cambiarIdioma (idioma) {
      this.$i18n.locale = idioma
      this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })
      localStorage.setItem('i18n', idioma)
      this.$router.go()
    },
    resetPassword () {
      this.$router.push({name: 'login.resetearPassword'})
    },
    // async getUserOneSignalId () {
    //   // OSPermissionSubscriptionState status = window.OneSignal.getPermissionSubscriptionState()
    //   await window.OneSignal.push(function() {
    //     window.OneSignal.getNotificationPermission(async function(permission) {
    //       if (permission) {
    //         console.log(await window.OneSignal.getUserId())
    //         return await window.OneSignal.getUserId()
    //       }
    //     })
    //   })
    // },
    async loguear (usermail, password) {
      try {
        this.botonDesactivado = true
        var codigoClientePrinex = this.codigoClientePrinex
        await this.logIn({usermail, password, tokenOneSignal: null/*await window.OneSignal.getUserId(), */, browser: navigator.appCodeName, platform: navigator.platform, codigoClientePrinex: codigoClientePrinex})
        let promises = [
          this.guardarConfiguracionInicial(),
          this.guardarTraduccionesPorDefecto(),
          this.obtenerTiposSolicitud(),
          this.obtenerConfiguracion(),
          this.cierreAutomaticoIncidencias()
        ]

        await Promise.all(promises)
        
        const usuario = JSON.parse(localStorage.getItem('usuario'))
        const configuracion = JSON.parse(localStorage.getItem('configuracion'))

        if ( usuario.roles.length === 1 && usuario.roles[0] == 'PV_CLIENTE' && configuracion.PV_WEB_PDC_CLIENTE_VER_INCIDENCIAS === 'N') {
          this.botonDesactivado = false
          this.addAlert({texto: this.$t('sinPermisosAccesoAplicacion'), color: 'error'})
          return
        }

        this.$router.push({
          name: 'home'
        })
      } catch (error) {
        this.botonDesactivado = false
        if(typeof error !== 'undefined' && error.expired) {
          this.$router.push({name: 'login.expiredPassword', params: {userId: error.userId, userMail: usermail, passwordActual: password}})
          return
        }
        else if (typeof error !== 'undefined' && error.unico)
        {
          this.$router.push({name: 'login.modificarPassword', params: {userId: error.userId, userMail: usermail, passwordActual: password}})
        }
        else {
          this.botonDesactivado = false
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    formularioPV1 () {
      this.dialog = true
    },
    iraPV1 (motivos) {

      this.enviarMensajePV1(motivos)
        .then(() => {
          this.dialog = false
          window.open('https://apps.prinex.com/posventa_old', '_blank');
        })
    }
  },
  computed: {
    ...mapGetters({
      version: 'version',
      versionApi: 'versionApi',
      getAgrupacionRolProveedor: 'getAgrupacionRolProveedor',
      getSubdominioRolProveedor: 'getSubdominioRolProveedor'
    }),
    localizationLogin () {
      return this.$t('sectionLogin')
    },
    version1 () {
      return this.$t('volverav1')
    }
  }
}
</script>


<style lang="sass" scoped>
  .custom-dialog
    position: fixed
    top: 0
    bottom: 0
    right: 0
    left: 0
    z-index: 6
    overflow-y: scroll
    transition-property: transform, width, -webkit-transform
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1)

  .custom-dialog-container
    position: relative
    min-height: 100%
    width: 100%
    display: flex
    align-content: center

  .custom-dialog-closer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: rgba(0,0,0,.8)
    &:hover
      cursor: pointer

</style>
